import sdkProvider from "../sdkProvider";

export const removeProduct = async (itemId) => {
  const sdk = await sdkProvider("savedItems");

  return sdk.removeItem({
    itemId,
  });
};
